import { FC } from "react"
import { DLMROI } from "../_models"

import { ROIDetails } from "./detail-panels/ROIDetails"
import { ROIItems } from "./detail-panels/ROIItems"

type Props = {
    details: DLMROI
}

const DLMROIDetailsSection: FC<Props> = ({details}) => {

    const isDoor = details?.dlmType?.door ?? false;
    return(
    <div className="d-flex flex-row flex-wrap gap-6 mb-4">
        <ROIDetails dlmAppId={0} details={details} />
        <ROIItems details={details} isDoor={isDoor} />
    </div>
    )
}

export { DLMROIDetailsSection }